import { render, staticRenderFns } from "./pointWindow.vue?vue&type=template&id=5ced785e&scoped=true"
import script from "./pointWindow.vue?vue&type=script&lang=js"
export * from "./pointWindow.vue?vue&type=script&lang=js"
import style0 from "./pointWindow.vue?vue&type=style&index=0&id=5ced785e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced785e",
  null
  
)

export default component.exports